import React, { FC, useRef, useState } from 'react';
import { FieldRenderProps as WrappedFieldProps } from 'react-final-form';
import { QuickQuoteFormProps } from '../../booking/quote/QuickQuoteTypes';
import { Modal, ToggleSelector } from '@trip-ux/components';
import type { ToggleSelectorProps } from '@trip-ux/components';
import { sanitizeDOM } from '@trip-ux/common';

export const GenericToggle: FC<WrappedFieldProps<string> & QuickQuoteFormProps & ToggleSelectorProps> = ({
  input,
  labels,
  meta,
  validateOnBlur, // when <Form> validates on blur, need to add this to force validation onChange for toggle only
  modalLink,
  ariaLabel,
  modalContent,
  inputOnChange,
  className,
  labelName,
  ...toggleProps
}) => {
  const [isOpen, setOpen] = useState(false);
  const modalLinkRef = useRef(null);
  const hasAdditionalInfo = modalLink && modalContent;
  return (
    <>
      <ToggleSelector
        {...input}
        {...toggleProps}
        error={meta.touched ? meta.error : undefined}
        onChange={val => {
          input.onChange(val);
          inputOnChange && inputOnChange(val);
          validateOnBlur && input.onBlur();
        }}
        className={className ? className : 'w-100 mt-auto'}>
        {labels && <>{labelName ? labels.formLabels[labelName] : labels.formLabels[input.name]} &nbsp;</>}
        {hasAdditionalInfo && (
          <a
            href="#modal"
            className="link"
            ref={modalLinkRef}
            aria-label={ariaLabel}
            onClick={e => {
              e.preventDefault();
              setOpen(true);
            }}>
            {modalLink}
          </a>
        )}
      </ToggleSelector>
      {hasAdditionalInfo && (
        <Modal
          id="additional-info"
          isOpen={isOpen}
          onClose={() => {
            setOpen(false);
          }}
          className={'modal-dialog modal-lg'}
          closeOnBackdropClick={false}
          closeAriaLabel={'Close'}
          ariaLabel={input.name}
          ariaLabelledby={`modal-label-${input.name}`}
          ariaDescribedby={`modal-content-${input.name}`}
          returnFocusComponent={modalLinkRef}>
          <div className={`modal-${input.name}`} dangerouslySetInnerHTML={{ __html: sanitizeDOM(modalContent) }} />
        </Modal>
      )}
    </>
  );
};
GenericToggle.displayName = 'GenericToggle';
